import * as React from 'react';

import SmsEngagementModalGraphicSVG from './sms-engagement-modal-graphic.svg';

import styles from './message-modal-graphic.module.css';

export function SmsEngagementModalGraphic() {
    return (
        <div className={styles.container}>
            <SmsEngagementModalGraphicSVG width={152} />
        </div>
    );
}
